import { render } from "./FooterNavigation.vue?vue&type=template&id=e2893472&scoped=true"
import script from "./FooterNavigation.vue?vue&type=script&lang=js"
export * from "./FooterNavigation.vue?vue&type=script&lang=js"

import "./FooterNavigation.vue?vue&type=style&index=0&id=e2893472&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2893472"]])

export default __exports__